import type { LocationQuery } from 'vue-router';
import type { ProductFiltersModel } from '../model';
import { isDefined } from '~/utils/guards/isDefined';
import { ensureArray } from '~/utils/ensureArray';

export function createFiltersFromQuery(
  query: LocationQuery
): ProductFiltersModel {
  const options: ProductFiltersModel = {};

  for (const key in query) {
    // This is a quick fix to remove utm parameters from filters.
    // The actual solution should be to display only available filters.
    // This is currently not possible, as possible filters are dependent on
    // the magento response. If we select a filter, which leads to zero
    // results, the filters is missing in the response...
    // https://gcp.baslerweb.com/jira/browse/WEB2-2323
    if (key.startsWith('utm_') || key.startsWith('_')) {
      continue;
    }

    const value = query[key];
    if (!isDefined(value)) {
      continue;
    }

    options[key] = ensureArray(value)
      .filter(isDefined)
      .map((value) => value.toString());
  }

  return Object.fromEntries(
    Object.entries(options).filter(([_, value]) => value.length > 0)
  );
}
